import { BehaviorSubject, Observable } from "rxjs";
import { UserSession } from "../interfaces/user-session";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HttpOptions } from '../interfaces/http-options';
import { DeleteResult } from "../models/net/result/crud/delete-result";
import { UpdateResult } from "../models/net/result/crud/update-result";
import { ReadResult } from "../models/net/result/crud/read-result";
import { CreateResult } from "../models/net/result/crud/create-result";
import { UtilityFunctions } from "./utility-functions";

export class HttpFactory {

    private constructor() { }

    public static anonGet<TResult>(http: HttpClient, apiPath: string, apiBaseUrl: string): Observable<TResult | null> {

        let result: BehaviorSubject<TResult | null> = new BehaviorSubject<TResult | null>(null);
        const fullPath: string = apiBaseUrl + apiPath;
        const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json" }) };

        http.get<TResult | null>(fullPath, httpOptions).subscribe((r: TResult | null) => {

            result.next(r);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public static get<TResult>(http: HttpClient, apiPath: string, apiBaseUrl: string): Observable<TResult | null> {

        let result: BehaviorSubject<TResult | null> = new BehaviorSubject<TResult | null>(null);
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.get<TResult | null>(fullPath, httpOptions).subscribe((r: TResult | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public static anonPost<TResult>(http: HttpClient, payload: any, apiPath: string, apiBaseUrl: string): Observable<TResult | null> {

        let result: BehaviorSubject<TResult | null> = new BehaviorSubject<TResult | null>(null);
        const fullPath: string = apiBaseUrl + apiPath;
        const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json" }) };

        http.post<TResult | null>(fullPath, payload, httpOptions).subscribe((r: TResult | null) => {

            result.next(r);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public static post<TResult>(http: HttpClient, payload: any, apiPath: string, apiBaseUrl: string): Observable<TResult | null> {

        let result: BehaviorSubject<TResult | null> = new BehaviorSubject<TResult | null>(null);
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.post<TResult | null>(fullPath, payload, httpOptions).subscribe((r: TResult | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }
}
